import { Voni } from '../client';

export interface ApiKey {
  id: number;
  name: string;
  prefix: string;
  last_used_at?: string;
  created_at: string;
  key?: string; // Only returned on creation
}

export interface ApiKeyCreateInput {
  name: string;
}

export class ApiKeysResource {
  constructor(private client: Voni) {}

  async list(): Promise<ApiKey[]> {
    return this.client.request<ApiKey[]>('GET', '/api-keys/');
  }

  async create(name: string): Promise<ApiKey> {
    const data: ApiKeyCreateInput = { name };
    return this.client.request<ApiKey>('POST', '/api-keys/', undefined, data);
  }

  async delete(keyId: number): Promise<void> {
    await this.client.request('DELETE', `/api-keys/${keyId}`);
  }
}
